export default {
	endPageText: 'Vos réponses ont bien été enregistrées, nous vous remercions de votre participation.'
};
